import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  SUPPORTED_LANGUAGES,
  getLanguageConfig,
} from '../../i18n/languages';

import './LanguageSelector.css';

export default function LanguageSelector() {
  const { t, i18n } = useTranslation('common');
  const [isChanging, setIsChanging] = useState(false);

  const currentLanguage = getLanguageConfig(
    i18n.resolvedLanguage || i18n.language,
  );

  const handleLanguageChange = async (event) => {
    const nextLanguage = event.target.value;

    if (
      !nextLanguage ||
      nextLanguage === currentLanguage.code ||
      isChanging
    ) {
      return;
    }

    setIsChanging(true);

    try {
      await i18n.changeLanguage(nextLanguage);
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('[i18n] 언어 변경 실패:', error);
      }
    } finally {
      setIsChanging(false);
    }
  };

  return (
    <div className="language-selector">
      <label
        className="sr-only"
        htmlFor="application-language"
      >
        {t('languages.label')}
      </label>

      <span
        className="language-selector-label"
        aria-hidden="true"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          focusable="false"
        >
          <circle cx="12" cy="12" r="9" />
          <ellipse cx="12" cy="12" rx="4" ry="9" />
          <path d="M3 12h18M5 6.5h14M5 17.5h14" />
        </svg>
      </span>

      <select
        id="application-language"
        value={currentLanguage.code}
        onChange={handleLanguageChange}
        disabled={isChanging}
        aria-label={t('languages.label')}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <option
            key={language.code}
            value={language.code}
          >
            {t(language.labelKey)}
          </option>
        ))}
      </select>
    </div>
  );
}
